import React from 'react'
import { MagentoCartTaxItem as CartTaxItem, MagentoMoney } from 'lib/types'
import { Price } from 'lib/shared'

interface Props {
  appliedTaxes: CartTaxItem[]
  subtotalExcludingTax: MagentoMoney
  subtotalIncludingTax: MagentoMoney
}

export const Tax: React.FC<Props> = ({
  subtotalExcludingTax,
  subtotalIncludingTax
}) => {
  const priceSubtotal = getTaxSubtotal(subtotalExcludingTax, subtotalIncludingTax)
  return (
    <>
      <tr
        className='tax-row'
      >
        <th>Tax</th>
        <td>
          <span>
            <Price
              {...priceSubtotal}
            />
          </span>
        </td>
      </tr>
    </>
  )
}

const getTaxSubtotal = (subtotalExcludingTax: MagentoMoney, subtotalIncludingTax: MagentoMoney) => {
  const value = getPrice(subtotalIncludingTax) - getPrice(subtotalExcludingTax)
  return {
    value,
    currency: subtotalExcludingTax.currency
  }
}

const getPrice = ({ value }: MagentoMoney) => {
  return value
}
